import Entry from 'admin-config/lib/Entry';

export default function languageSwitcher($translate, Api) {
    return {
        scope: {
            'default': '&'
        },
        restrict: 'E',
        link: {
            pre: function(scope) {
                var lang = Api.LANG_COOKIE || 'lang';

                scope.languages = $translate.getAvailableLanguageKeys();

                if(Cookies.get(lang) )
                    $translate.use(Cookies.get(lang));

                scope.$root.current_language = scope.current = $translate.use();

                scope.flags = {
                    'en' : 'us',
                    'ca' : 'cat'
                };
                scope.flags_string = {
                    'es' : 'SPANISH',
                    'en' : 'ENGLISH',
                    'ca' : 'CATALAN'
                };

                scope.switchLanguage = function(code){
                    scope.$root.current_language = scope.current = code;
                    $translate.use(code);
                    Cookies.set(lang, code);
                };

                scope.getFlag = function(code){
                    if(scope.flags[code])
                        return scope.flags[code];

                    return code;
                }

                scope.getFlagString = function(code){
                    if(scope.flags_string[code])
                        return scope.flags_string[code];

                    return code;
                }
            }
        },
        template:
            `
            <md-menu md-position-mode="target-right target" >
                <md-button aria-label="Change Language" ng-click="$mdMenu.open($event)">
                    <span class="flag-icon flag-icon-{{ getFlag(current) | translate }}"></span> {{ getFlagString(current) | translate }}
                </md-button>
                <md-menu-content width="4">
                    <md-menu-item ng-repeat="lang in languages">
                        <md-button ng-click="switchLanguage(lang)">
                            <span class="flag-icon flag-icon-{{ getFlag(lang) | translate }}"></span> {{ getFlagString(lang) | translate }}
                        </md-button>
                    </md-menu-item>
                </md-menu-content>
            </md-menu>
`
    };
};

languageSwitcher.$inject = [];


/** WEBPACK FOOTER **
 ** ./js/directives/language_switcher.js
 **/